<script>
export default {
    name: 'DashboardCol',
    props: {
        span: {
            type: Number,
            default: 12,
            validator: (value) => value >= 1 && value <= 12,
        },
    },
    computed: {
        columnClass() {
            return `col-md-${this.span}`;
        },
    },
};
</script>

<template>
    <div :class="columnClass">
        <slot />
    </div>
</template>
